import { Dispatch } from "redux";
import {
    setUserSummaryReferenceData,
    setUserSummaryReferenceDataLoading
} from "@redux/actions/user-summary-actions";
import { getMonthlyUsersReferenceDataRequest } from "@requests/reports/get-monthly-users-reference-data";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getUserSummaryReferenceDataReduxRequest = (dispatch: Dispatch) => async () => {
    dispatch(setUserSummaryReferenceDataLoading(true));
    const { data, error } = await getMonthlyUsersReferenceDataRequest();
    if (data) {
        dispatch(setUserSummaryReferenceData(data));
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.referenceData.error.title,
                resources.requests.referenceData.error.message
            );
        }
        dispatch(setUserSummaryReferenceDataLoading(false));
    }
};